import shareGuide from './shareGuide2.vue'
export default {
	install(Vue, i18n) {
		const shareGuideDialog = Vue.extend(shareGuide);
		let instance;
		let type = '';
		shareGuide.open = function (closeCBK, options={}) {
			if (!instance || type !== options.type) {
				type = options.type;
				instance = new shareGuideDialog({
					i18n,
					propsData: {type: options && options.type},
				}).$mount()
			}
			document.body.appendChild(instance.$el);
			Vue.nextTick(() => {
				instance.open(closeCBK);
			});
			return instance;
		};

		Vue.prototype.$welcome = shareGuide;
	}
}